import { render, staticRenderFns } from "./Webhooks.vue?vue&type=template&id=161ab53b"
import script from "./Webhooks.vue?vue&type=script&lang=js"
export * from "./Webhooks.vue?vue&type=script&lang=js"
import style0 from "./Webhooks.vue?vue&type=style&index=0&id=161ab53b&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports